<template>
  <div>
    <HeadlineContainer headline="People" :breadcrumbs="[{text: 'People'}]">
      <div class="btn-group">
        <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-cogs"></i> Functions <span class="caret"></span>
        </button>

        <ul class="dropdown-menu">
          <li>
            <router-link to="/people/create">
              <i class="fa fa-plus"></i> Create
            </router-link>
          </li>

          <li>
            <router-link to="/people/imports/create">
              <i class="fa fa-cloud-upload-alt"></i> Import
            </router-link>
          </li>
        </ul>
      </div>
    </HeadlineContainer>

    <div class="container">
      <PersonList/>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import PersonList from "@/components/People/People/Panels/List";

export default {
  components: {PersonList, HeadlineContainer},
}
</script>
